<template>
    <div class="m-nav" v-bind:class="{pullleft: showMNav}">
        <div class="menu" id="menu">
            <ul>
                <li v-for="(value, key) in nav">
                    <img v-bind:src="icon[key]" alt="menu-icon">
                    <a :href="value" v-if="!isObj(value)">{{key}}</a>
                    <div class="toggle-item" v-if="isObj(value)" @click="toggleSecondNav(key)">
                        {{key}}
                        <span class="on" v-show="show[key]"></span>
                        <span class="off" v-show="!show[key]"></span>
                    </div>
                    <div class="menu-second-item" v-show="show[key]">
                        <div class="second-item" v-for="(value2, key2) in value" v-if="isObj(value)">
                            <img  v-bind:src="icon[key2]" alt="menu-icon">
                            <a :href="value2">{{key2}}</a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import vue from 'vue'
    import axios from 'axios'

    export default {
        props: ["showMNav"],
        data() {
            return {
                nav: null,
                show: {
                    "分类": false,
                    "资源": false
                },
                icon: {
                    '首页': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/home.png',
                    '分类': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/compass.png',
                    '电车库': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/car.png',
                    '资源': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/download.png',
                    '订阅': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/讯息.png',
                    '讯息': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/讯息.png',
                    '声音': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/声音.png',
                    '新政': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/新政.png',
                    '产业': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/产业.png',
                    '评测': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/评测.png',
                    '政策规划库': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/政策规划文件.png',
                    '行业标准库': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/行业国家标准.png',
                    '数据图表报告': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/数据图表报告.png',
                    '补贴免税查询': 'http://www.evhui.com/wp-content/wptouch-data/icons/custom/补贴免税查询.png'
                }
            }
        },
        mounted() {
            this.getNav();
        },
        methods: {
            getNav() {
                let that = this;
                axios.get('/api/blog/menu').then((res) => {
                    that.nav = res.data.data;
                    console.log(that.nav);
                }).catch((err) => {
                    console.log(err);
                });
            },
            isObj(val) {
                return Object.prototype.toString.call(val) === '[object Object]'
            },
            toggleSecondNav(key) {
                this.show[key] = !this.show[key];
            }
        }
    }
</script>

<style lang="scss" scoped>
    $maincolor: #0666b2;
    @media (max-width: 414px) {
        .m-nav {
            position: absolute;
            top: 0;
            right: -270px;
            z-index: 100;
            width: 0;
            height: 100%;
            background-color: #293a53;
            transition: -webkit-transform 0.33s cubic-bezier(0.29, 0.05, 0.14, 0.87);
            overflow: scroll;
            a,
            .toggle-item {
                position: relative;
                display: block;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                padding-top: 15px;
                padding-bottom: 15px;
                padding-right: 32px;
                color: #fff;
                text-shadow: rgba(0,0,0,.3) 0 -1px 0;
                transition: transform 0.33s cubic-bezier(0.29, 0.05, 0.14, 0.87);
            }
            .toggle-item {
                span {
                    content: "";
                    position: absolute;
                    top: 16px;
                    right: 16px;
                    width: 16px;
                    height: 16px;
                    background-image: url("../../static/img/arrow.png");
                    background-size: 100%;
                    background-repeat: no-repeat;
                    transition: transform 0.33s cubic-bezier(0.29, 0.05, 0.14, 0.87);
                }
                .off {
                    transform: rotate(180deg);
                }
            }
            li {
                text-shadow: rgba(0,0,0,.3) 0 -1px 0;
                border-bottom: 1px solid rgba(0,0,0,.12);
                border-top: 1px solid rgba(255,255,255,.06);
                img {
                    width: 26px;
                    height: 26px;
                    position: relative;
                    float: left;
                    padding-right: 6px;
                    top: 8px;
                    padding-left: 6px;
                }
            }
            .menu-second-item {
                .second-item {
                    padding-left: 15px;
                }
            }
        }
        .pullleft {
            width: 270px;
            transform: translateX(-270px);
        }
    }
</style>



// WEBPACK FOOTER //
// Mnav.vue?3985dbb6